window.vf.enterpriseIframeModal = (function () {
    'use strict';
    var modal = null;

    var modalsToInject = [
        {
            'stdTriggerLink': 'https://eweb8.vfd2-testnet.de/BusinessContact',
            'stdHeadline': 'Vereinbaren Sie einen Rückruf',
            'stdIframeLink': 'https://eweb8.vfd2-testnet.de/business/kontaktformular/'
        },
        {
            'stdTriggerLink': 'https://eweb8.vfd2-testnet.de/business/hilfe-support/business-newsletter.html',
            'stdHeadline': 'Melden Sie sich für den Newsletter an',
            'stdIframeLink': 'https://business.vodafone.de/forms_pages_compact_newsletter_registration.html'
        }
    ];

    var modalHTML = '<div class="ep-modal ep-modal-iframe modal fade" id="iframeModal" tabindex="-1" role="dialog" aria-labelledby="iframeModal" aria-hidden="true">' +
        '<div class="modal-dialog modal-dialog-centered ep-modal__dialog col-12 col-md-6" role="document">' +
            '<div class="modal-content ep-modal__content">' +
               '<div class="modal-header ep-modal__header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                        '<span aria-hidden="true">' +
                            '<svg class="i-dialog-close-sml i-white i-sml">' +
                                '<use xlink:href="/simplicity/svgdefs.svg#i-dialog-close-sml">' +
                            '</svg>' +
                        '</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body ep-modal__body">' +
                    '<iframe></iframe>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';

    function injectIframe(element, modalConfigData) {
        var modalBody = element.querySelector('#iframeModal .ep-modal__body');

        var iframe = document.querySelector('#iframeModal .ep-modal__body iframe');
        iframe.setAttribute('id', 'modalIframe');
        iframe.setAttribute('src', modalConfigData.stdIframeLink);
        iframe.setAttribute('scrolling', 'no');
        iframe.style.border = 'none';
        iframe.style.width = '100%';
        iframe.style.height = '100%';
        modalBody.appendChild(iframe);
        iFrameResize({log: false}, '#modalIframe');
    }

    function eventListener(element, modalElement, modalConfigData) {
        element.addEventListener('click', function(e) {
            e.preventDefault();
            injectIframe(modalElement, modalConfigData);
            $(modal).modal('toggle');

            var flyout = window.vf.enterpriseFlyout;
            if (flyout) {
                flyout.closeFlyout();
            }
        });
    }

    function registerClick(modalElement, modalConfigData) {
        var trigger = document.querySelectorAll('.mod-ep-flyout__content [href*="' + modalConfigData.stdTriggerLink + '"]');

        if ('undefined' === typeof trigger || !trigger.length) {
            return;
        }

        for (var i = 0; i < trigger.length; i++) {
            eventListener(trigger[i], modalElement, modalConfigData);
        }
    }

    function init() {
        var nodeToAppend = document.getElementById('top');

        var modalContainer = document.createElement('div');
        modalContainer.innerHTML = modalHTML.trim();
        nodeToAppend.appendChild(modalContainer.firstChild);

        modal = document.getElementById('iframeModal');

        for (var i = 0; i < modalsToInject.length; i++) {
            registerClick(modal, modalsToInject[i]);
        }
    }

    return {
        'init': init
    };

})();
